import React from 'react';
import { Label } from '@/components/ui/label';
import { Textarea } from '@/components/ui/textarea';
import { clockVarianceText } from '@/lib/clockVariance';

/** Required early/late reason box shown when a clock-in/out is outside the grace window (renders nothing otherwise). */
export function ClockVarianceReason({ action, variance, value, onChange, id = 'clock-variance-reason', testId = 'clock-variance-block' }) {
  if (!variance) return null;
  const { label, placeholder } = clockVarianceText(action, variance);
  return (
    <div className="mb-4 space-y-2 rounded-lg border border-amber-500/30 bg-amber-500/5 p-3" data-testid={testId}>
      <Label htmlFor={id} className="text-sm font-semibold">{label}</Label>
      <Textarea
        id={id}
        rows={3}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        data-testid={`${id}-input`}
      />
      <p className="text-[11px] text-muted-foreground">This is recorded as an attendance exception for your coordinator to review.</p>
    </div>
  );
}

export default ClockVarianceReason;
